import React from "react";

export default function Desktop() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        d="M35.75 6.875H8.25C7.15598 6.875 6.10677 7.3096 5.33318 8.08318C4.5596 8.85677 4.125 9.90598 4.125 11V30.25C4.125 31.344 4.5596 32.3932 5.33318 33.1668C6.10677 33.9404 7.15598 34.375 8.25 34.375H20.625V37.125H16.5C16.1353 37.125 15.7856 37.2699 15.5277 37.5277C15.2699 37.7856 15.125 38.1353 15.125 38.5C15.125 38.8647 15.2699 39.2144 15.5277 39.4723C15.7856 39.7301 16.1353 39.875 16.5 39.875H27.5C27.8647 39.875 28.2144 39.7301 28.4723 39.4723C28.7301 39.2144 28.875 38.8647 28.875 38.5C28.875 38.1353 28.7301 37.7856 28.4723 37.5277C28.2144 37.2699 27.8647 37.125 27.5 37.125H23.375V34.375H35.75C36.844 34.375 37.8932 33.9404 38.6668 33.1668C39.4404 32.3932 39.875 31.344 39.875 30.25V11C39.875 9.90598 39.4404 8.85677 38.6668 8.08318C37.8932 7.3096 36.844 6.875 35.75 6.875ZM8.25 9.625H35.75C36.1147 9.625 36.4644 9.76987 36.7223 10.0277C36.9801 10.2856 37.125 10.6353 37.125 11V24.75H6.875V11C6.875 10.6353 7.01987 10.2856 7.27773 10.0277C7.53559 9.76987 7.88533 9.625 8.25 9.625ZM35.75 31.625H8.25C7.88533 31.625 7.53559 31.4801 7.27773 31.2223C7.01987 30.9644 6.875 30.6147 6.875 30.25V27.5H37.125V30.25C37.125 30.6147 36.9801 30.9644 36.7223 31.2223C36.4644 31.4801 36.1147 31.625 35.75 31.625Z"
        fill="#FDFEFF"
      />
    </svg>
  );
}
